import { IoChevronUp } from "react-icons/io5";
import React, { useEffect, useState } from "react";
const ScrollToTop = () => {
  const [visible, setvisible] = useState(false);
  const ToggleVisible = () => {
    let scrolled = document.documentElement.scrollTop;
    if (scrolled > 300) setvisible(true);
    else setvisible(false);
  };
  useEffect(() => {
    window.addEventListener("scroll", ToggleVisible);
    return () => {
      window.removeEventListener("scroll", ToggleVisible);
    };
  }, []);
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <button
      id="return-to-top"
      onClick={() => scrollToTop()}
      style={{ display: visible ? "flex" : "none" }}
    >
      <span>
        <IoChevronUp size={20} />
      </span>
    </button>
  );
};

export default ScrollToTop;
